"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

var withTheme_1 = require("../utils/withTheme");

var Slider_1 = __importDefault(require("./Slider"));

var VolumeIcon_1 = __importDefault(require("./icons/VolumeIcon"));

var handleButtonClick = function handleButtonClick(e, props) {
  e.preventDefault();
  toggleMute(props);
};

var handleButtonTouchEnd = function handleButtonTouchEnd(e, props) {
  e.preventDefault();
  toggleMute(props);
};

var toggleMute = function toggleMute(props) {
  if (!props.controller) {
    return;
  }

  if (props.muted) {
    props.controller.unMute();
  } else {
    props.controller.mute();
  }
};

var handleButtonMouseDown = function handleButtonMouseDown(e) {
  // Prevent focus on mouse down
  e.preventDefault();
};

var getVolumeClass = function getVolumeClass(_a) {
  var value = _a.value,
      muted = _a.muted;

  if (muted) {
    return 'volume-control--muted';
  }

  if (value > 0.5) {
    return 'volume-control--high';
  }

  if (value > 0.25) {
    return 'volume-control--low';
  }

  return 'volume-control--very-low';
};

var VolumeButton = function VolumeButton(props, context) {
  return withTheme_1.withTheme(context.theme, 'volume-button')(React.createElement("button", {
    onClick: function onClick(e) {
      return handleButtonClick(e, props);
    },
    onTouchEnd: function onTouchEnd(e) {
      return handleButtonTouchEnd(e, props);
    },
    onMouseDown: handleButtonMouseDown,
    title: "Ljud " + (props.muted ? 'på' : 'av')
  }, React.createElement(VolumeIcon_1["default"], {
    muted: props.muted,
    volume: props.value
  })));
};

VolumeButton.contextTypes = {
  theme: PropTypes.object
};

var VolumeControl =
/** @class */
function (_super) {
  __extends(VolumeControl, _super);

  function VolumeControl() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this._setActive = function () {
      return _this.props.onActiveChange(true);
    };

    _this._setPassive = function () {
      return _this.props.onActiveChange(false);
    };

    _this._handleSliderValueChange = function (value) {
      if (!_this.props.controller) {
        return;
      }

      try {
        _this.props.controller.setVolume(value);
      } catch (e) {
        _this.setState(function () {
          throw e;
        });
      }
    };

    return _this;
  }

  VolumeControl.prototype.render = function () {
    return withTheme_1.withTheme(this.context.theme, {
      'volume-control': true
    })(React.createElement("div", {
      onMouseEnter: this._setActive,
      onMouseLeave: this._setPassive
    }, React.createElement(VolumeButton, __assign({}, this.props)), React.createElement(Slider_1["default"], {
      value: this.props.value,
      max: 1,
      orientation: "vertical",
      onValueChange: this._handleSliderValueChange,
      onFocus: this._setActive,
      onBlur: this._setPassive,
      ariaLabel: "Volym",
      ariaValueText: (this.props.value * 100).toFixed(0) + "%"
    })));
  };

  VolumeControl.contextTypes = {
    theme: PropTypes.object
  };
  VolumeControl.propTypes = {
    value: PropTypes.number.isRequired,
    muted: PropTypes.bool.isRequired,
    controller: PropTypes.object
  };
  VolumeControl.defaultProps = {
    onActiveChange: function onActiveChange(active) {} // tslint:disable-line

  };
  return VolumeControl;
}(React.Component);

exports["default"] = VolumeControl;